import { render, staticRenderFns } from "./TabNavButton.vue?vue&type=template&id=3787e42c"
import script from "./TabNavButton.vue?vue&type=script&lang=js"
export * from "./TabNavButton.vue?vue&type=script&lang=js"
import style0 from "./TabNavButton.vue?vue&type=style&index=0&id=3787e42c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports